import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from '../../store';
import {
  setClearAllFilter,
  setClearCrumbsFilter,
} from '../../store/reducers/search/searchDataSlice';
import { setClearAllAdditionalFilters } from '../../store/reducers/search/otherFiltersDataSlice';
import bemClassName from '../../utils/bem';
import Icon from '../../UI/Icon';
import './index.scss';
import { IBreadCrumbs } from './interface';

const catalog = bemClassName('catalog');

const Breadcrumbs: React.FC<IBreadCrumbs> = ({ city, roomsCrumb, apartamentName }) => {
  const dispatch = useDispatch();
  const windowWidth = useSelector((state: RootState) => state.window.windowWidth);
  // Функция для определения последней крошки
  const isLastCrumb = (index: number) => {
    if (index === 1 && !roomsCrumb && !apartamentName) {
      return true; // Если есть только city
    }
    if (index === 2 && !apartamentName) {
      return true; // Если есть city и roomsCrumb, но нет apartamentName
    }
    if (index === 3) {
      return true; // Если есть все три элемента: city, roomsCrumb и apartamentName
    }
    return false; // В остальных случаях
  };

  return (
    <>
      {windowWidth > 959 && (
        <div className={catalog('bread-crumbs')}>
          <span className={catalog('crumbs-text')}>Каталог</span>
          {city && <Icon externalClassName={catalog('crumb-icon')} iconName="crumb_arrow" />}
          {city && (
            <Link
              onClick={() => {
                dispatch(setClearAllFilter());
                dispatch(setClearAllAdditionalFilters());
              }}
              to={`/catalog/${city}`}
              style={{ pointerEvents: isLastCrumb(1) ? 'none' : 'auto' }}>
              {city}
            </Link>
          )}
          {roomsCrumb && <Icon externalClassName={catalog('crumb-icon')} iconName="crumb_arrow" />}
          {roomsCrumb && (
            <Link
              onClick={() => {
                dispatch(setClearCrumbsFilter());
                dispatch(setClearAllAdditionalFilters());
              }}
              to={`/catalog/${city}?rooms=${encodeURIComponent(
                roomsCrumb ? roomsCrumb.toString() : '',
              )}`}
              style={{
                pointerEvents: isLastCrumb(2) ? 'none' : 'auto',
              }}>{`${roomsCrumb}-комнатные квартиры`}</Link>
          )}
          {apartamentName && (
            <Icon externalClassName={catalog('crumb-icon')} iconName="crumb_arrow" />
          )}
          {apartamentName && (
            <Link
              to={`/catalog/${city}?rooms=${encodeURIComponent(
                roomsCrumb ? roomsCrumb.toString() : '',
              )}/${encodeURIComponent(apartamentName)}`}
              style={{
                pointerEvents: isLastCrumb(3) ? 'none' : 'auto',
              }}>
              {apartamentName}
            </Link>
          )}
        </div>
      )}
    </>
  );
};

// eslint-disable-next-line
export default Breadcrumbs;
